export default "__VITE_ASSET__B3wnKR13__"